<template>
  <div class="sidebar-footer" :class="{ 'collapsed': isCollapsed }">
    <router-link to="/profile" class="profile-button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
      <span v-if="!isCollapsed">My Profile</span>
    </router-link>

    <button @click="$emit('logout')" class="logout-button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
      <span v-if="!isCollapsed">Logout</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SidebarFooter',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['logout']
}
</script>

<style scoped>
.sidebar-footer {
  margin-top: auto;
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar-footer.collapsed {
  padding: 1rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-button, .logout-button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  margin-bottom: 0.75rem;
  font-weight: 500;
  font-size: 0.9rem;
}

.sidebar-footer.collapsed .profile-button, 
.sidebar-footer.collapsed .logout-button {
  width: auto;
  padding: 0.5rem;
  justify-content: center;
}

.profile-button:hover, .logout-button:hover {
  background: rgba(255, 255, 255, 0.07);
}

.profile-button svg, .logout-button svg {
  width: 18px;
  height: 18px;
  margin-right: 0.9rem;
  transition: all 0.2s ease;
}

.sidebar-footer.collapsed .profile-button svg,
.sidebar-footer.collapsed .logout-button svg {
  margin-right: 0;
}

.logout-button {
  background: rgba(239, 68, 68, 0.05);
  color: rgba(239, 68, 68, 0.9);
  border-color: rgba(239, 68, 68, 0.1);
}

.logout-button:hover {
  background: rgba(239, 68, 68, 0.08);
}

:root[data-theme="light"] .sidebar-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

:root[data-theme="light"] .profile-button {
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.8);
}

:root[data-theme="light"] .profile-button:hover {
  background: rgba(0, 0, 0, 0.05);
}

:root[data-theme="light"] .logout-button {
  background: rgba(239, 68, 68, 0.05);
  color: rgba(239, 68, 68, 0.9);
  border-color: rgba(239, 68, 68, 0.1);
}

:root[data-theme="light"] .logout-button:hover {
  background: rgba(239, 68, 68, 0.08);
}
</style> 